import { render, staticRenderFns } from "./SupplierAgents.vue?vue&type=template&id=2866b47a&scoped=true&"
import script from "./SupplierAgents.vue?vue&type=script&lang=js&"
export * from "./SupplierAgents.vue?vue&type=script&lang=js&"
import style0 from "./SupplierAgents.vue?vue&type=style&index=0&id=2866b47a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2866b47a",
  null
  
)

export default component.exports